import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { TreeViewModule } from "@progress/kendo-angular-treeview";
import { SharedModule } from "app/_shared/shared.module";
import { WindowModule } from "@progress/kendo-angular-dialog";
import { CedFrameLayoutModule } from "ced-ng-library";
import { DraftDossierRoutingModule } from "./draft-dossier-routing.module";
import { DraftDossierListComponent } from "./draft-dossier-list/draft-dossier-list/draft-dossier-list.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    WindowModule,
    TreeViewModule,    
    DraftDossierRoutingModule,
    CedFrameLayoutModule
  ],
  declarations: [DraftDossierListComponent],
  entryComponents:[]
})
export class DraftDossierModule {}